/* eslint-disable no-underscore-dangle */
/* eslint-disable no-shadow */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
import React from "react";
import Hidden from "@material-ui/core/Hidden";
import { connect } from "react-redux";
import { PageWrapper, TableWrapper } from "../../../../shared/layout";
import { templateStrings, MessageType } from "../../../../Constant";
import "./vehicleContract.css";
import {
  Button, BarLoader, ConfirmationModal,
} from "../../../../shared/widgets";
import CreateContractModal from "../createContract/createContract";
import CollectionHandledByErrorModal from "../CollectionHandledByErrorModal";
import { fetchAllContractAction } from "../../../../redux/action-creators/allContractsActionCreator";
import { closeActiveContractsService, closeUpcomingContractsService } from "../../../../services/contractService";
import { setTokenExpired } from "../../../../redux/actions/authActions";
import { setNotificationMessage } from "../../../../redux/actions/notificationAction";
import { GenericLoaderComponent } from "../../../../shared/widgets/genericLoader";
import ContractModal from "../../../../shared/components/commonComponents/ContractModal";
import RenewConfirmationModal from "./renewConfirmationModal";
import RenewModal from "../createContract/renewContract";

class VehicleContract extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      steps: this.getSteps(),
      content: [],
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      selected: [],
      vehicleDetails: {},
      showCollectionHandledByErrorModal: false,
      errorContent: null,
      isLoaderVisible: false,
      showRenewConfirmationModal: false,
    };
    this.vehicleContractGetList = this.vehicleContractGetList.bind(this);
    this.closeDetailModal = this.closeDetailModal.bind(this);
    this.openRenewConfirmationModal = this.openRenewConfirmationModal.bind(this);
    this.openConfirmationModal = this.openConfirmationModal.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  componentDidMount() {
    const { location } = this.props;
    this.vehicleContractGetList();
    this.setState({
      vehicleDetails: location.state,
    });
  }

  handleChange = (input, value) => {
    const { location, fetchVehicles } = this.props;
    const { pageNo } = this.state;
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        fetchVehicles(location.state.busNumber, pageNo);
      }
    });
  };

  handleAction(data) {
    this.openDetailModal(data);
  }

  getSteps() {
    return ["Terms", "Commercials"];
  }

  getExpenseDisplayName(name) {
    const expense = templateStrings.expenseArray.find((eachExpense) => eachExpense.name === name);
    return expense.label;
  }

  contractHandler = (data, requestType) => {
    const { vehicleDetails } = this.state;
    if (!vehicleDetails.borneBy) {
      return this.errorModalHandler(vehicleDetails.busNumber);
    }
    this.open(data, requestType);
    return null;
  };

  errorModalHandler = (errorContent = null) => {
    const { showCollectionHandledByErrorModal } = this.state;
    this.setState({
      errorContent,
      showDetailModal: false,
      showCollectionHandledByErrorModal: !showCollectionHandledByErrorModal,
    });
  };

  /**
   * Call when Add modal Opens.
   */
  open(data, requestType) {
    this.setState({
      showDetailModal: false,
      showConfirmationModal: false,
      showModal: true,
      contractDetails: data,
      requestType,
    });
  }

  /**
   * Call when Detail modal Opens.
   */
  openDetailModal(data) {
    this.setState({
      showConfirmationModal: false,
      showModal: false,
      showDetailModal: true,
      contractDetails: data,
    });
  }

  closeDetailModal() {
    this.setState({
      showDetailModal: false,
      contractDetails: null,
    });
  }

  closeConfirmationModal() {
    this.setState({
      showDetailModal: false,
      showConfirmationModal: false,
    });
  }

  closeRenewConfirmationModal() {
    this.setState({
      showDetailModal: false,
      showRenewConfirmationModal: false,
    });
  }

  showNotification(type, msg) {
    const { initiateNotification } = this.props;
    initiateNotification({
      type,
      message: msg || "Something went wrong",
    });
  }

  /**
   * Used to show Modal for "Add new Contract"
   */
  vehicleContractdisplayDetailModal() {
    const { contractDetail } = templateStrings;
    return (
      <ContractModal
        inputProps={this.props}
        state={this.state}
        closeDetailModal={this.closeDetailModal}
        contractHandler={this.contractHandler}
        openConfirmationModal={this.openConfirmationModal}
        openRenewConfirmationModal={this.openRenewConfirmationModal}
        getExpenseDisplayName={this.getExpenseDisplayName}
        contractDetail={contractDetail}
      />
    );
  }

  /**
   * API call to get vehicles.
   * @param pageNo current page number
   */
  vehicleContractGetList() {
    const { fetchVehicles, location } = this.props;
    const { pageNo, rowsPerPage } = this.state;
    fetchVehicles(location.state.busNumber, pageNo, rowsPerPage);
  }

  /**
   * Call when Add modal Opens.
   */
  openConfirmationModal(dataId) {
    this.setState({
      showDetailModal: false,
      showConfirmationModal: true,
      contractId: dataId,
    });
  }

  openRenewConfirmationModal(data) {
    this.setState({
      showDetailModal: false,
      showRenewConfirmationModal: true,
      contractId: data?._id,
      contractDetails: data,
    });
  }

  /**
   * Used to show Modal for confirmation
   */
  displayConfirmationModal() {
    const {
      content, fetchVehicles, location, setTokenExpired: setTokenExpiredProp,
    } = this.props;
    const { showConfirmationModal, contractId, vehicleDetails } = this.state;
    return (
      <ConfirmationModal
        showModal={showConfirmationModal}
        title="Are you sure you want to terminate this contract?"
        // content="Are you sure you want to terminate this contract?"
        yesButtonText="Terminate"
        messageCallBack={(type) => {
          if (type === MessageType.SUCCESS) {
            this.setState({ isLoaderVisible: true }, () => {
              (content.find((item) => item._id === contractId).status.toLowerCase() === "active"
                ? closeActiveContractsService([vehicleDetails.busNumber])
                : closeUpcomingContractsService([vehicleDetails.busNumber]))
                .then(() => {
                  this.setState({ pageNo: 0, isLoaderVisible: false });
                  fetchVehicles(location.state.busNumber, 0);
                  this.showNotification(MessageType.SUCCESS, "Contract terminated successfully");
                })
                .catch((err) => {
                  if (err.message.includes("Invalid token")) {
                    setTokenExpiredProp(true);
                  } else {
                    this.showNotification(MessageType.ERROR, err.message);
                  }
                });
            });
          }
          this.closeConfirmationModal();
        }}
      />
    );
  }

  displayRenewConfirmationModal() {
    const { showRenewConfirmationModal, contractDetails } = this.state;
    return (
      <RenewConfirmationModal
        showModal={showRenewConfirmationModal}
        callBack={(type) => {
          if (type === "renew") {
            this.contractHandler(contractDetails, "renew");
          }
          if (type === "edit") {
            this.contractHandler(contractDetails, "edit");
          }
          this.closeRenewConfirmationModal();
        }}
      />
    );
  }

  /**
   * Used to show Modal for "Add new Contract"
   */
  displayModal() {
    const {
      requestType, contractDetails, showModal, activeStep, vehicleDetails, steps,
    } = this.state;
    const {
      city, location, fetchVehicles, initiateNotification,
    } = this.props;
    if (requestType === "renew") {
      return (
        <RenewModal
          contractData={contractDetails}
          city={city}
          showModal={showModal}
          requestType={requestType}
          callBack={() => {
            this.setState({
              pageNo: 0,
              showModal: false,
            });
            fetchVehicles(location.state.busNumber, 0);
          }}
        />
      );
    }
    return (
      <CreateContractModal
        showModal={showModal}
        forEdit
        activeStep={activeStep}
        selectedVehicle={[vehicleDetails]}
        contractData={contractDetails}
        steps={steps}
        city={city}
        requestType={requestType}
        messageCallBack={(type, msg) => {
          if (type) {
            if (type === MessageType.SUCCESS) {
              this.setState({ pageNo: 0 });
              fetchVehicles(location.state.busNumber, 0);
            }
            initiateNotification({
              type,
              message: msg,
            });
          }
          this.setState({
            showModal: false,
            activeStep: 0,
          });
        }}
      />
    );
  }

  /*
   * Display Error on create contract for without handle by
   */

  displayCollectionHandledByErrorModal() {
    const { showCollectionHandledByErrorModal, errorContent } = this.state;
    return (
      <CollectionHandledByErrorModal
        showModal={showCollectionHandledByErrorModal}
        content={errorContent}
        closeHandler={this.errorModalHandler}
        defaultContent={"Please select the \"Collection Handled By\" for following vehicle:"}
      />
    );
  }

  render() {
    const templateString = templateStrings.vehicleContract;
    const {
      headerLoader, content, totalItems, refreshUpliftStatus,
    } = this.props;
    const {
      selected, pageNo, rowsPerPage, vehicleDetails, isLoaderVisible,
      showModal, showDetailModal, showConfirmationModal, showCollectionHandledByErrorModal,
      showRenewConfirmationModal,
    } = this.state;
    let header = `${vehicleDetails.busNumber} `;
    if (vehicleDetails.operatorName) {
      header += `,${vehicleDetails.operatorName}`;
    }
    return (
      <div>
        {isLoaderVisible && <GenericLoaderComponent absolute />}
        <PageWrapper>
          <PageWrapper.Header
            heading={header}
            showBackArrow
            hideS
          >
            <Hidden only={["sm", "xs"]}>
              <div className="btn-wrapper">
                <Button
                  onClick={() => this.contractHandler(null, "create")}
                  disable={
                    refreshUpliftStatus === "Data Sync In Process"
                  }
                  buttonText="Create New Contract"
                />
              </div>
            </Hidden>
          </PageWrapper.Header>
          <PageWrapper.Body>
            <BarLoader scope="header" />

            <TableWrapper
              content={!headerLoader && content}
              selected={selected}
              pageNo={pageNo}
              uniqueKey="fromDate"
              rowsPerPage={rowsPerPage}
              count={totalItems}
              handleChange={this.handleChange}
              templateString={templateString}
              selectionAllowed={false}
              handleAction={this.handleAction}
            />

            {showModal && this.displayModal()}

            {showDetailModal
              && this.vehicleContractdisplayDetailModal()}
            {showConfirmationModal
              && this.displayConfirmationModal()}
            {showCollectionHandledByErrorModal
              && this.displayCollectionHandledByErrorModal()}
            {showRenewConfirmationModal
              && this.displayRenewConfirmationModal()}
          </PageWrapper.Body>
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log('state in mapStateToProps: ', state);
  return {
    content:
      state?.Contracts?.vehicleAllContracts?.items
      || [],
    totalItems:
      (state
        && state.Contracts
        && state.Contracts.vehicleAllContracts
        && state.Contracts.vehicleAllContracts.totalItems)
      || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    city: state.Cities.selectedCity,
    refreshUpliftStatus: state && state.Contracts && state.Contracts.refreshUpliftStatus,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchVehicles: (vehicleNo, pageNo) => {
    dispatch(fetchAllContractAction({ vehicleNo, pageNo }));
  },
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
  setTokenExpired: (value) => {
    dispatch(setTokenExpired(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VehicleContract);
